var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "rgba(255, 255, 255, 0.6)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491 1005 c-91 -20 -235 -94 -315 -162 -85 -71 -176 -176 -176 -203 0 -27 91 -132 176 -203 83 -70 224 -142 320 -162 88 -19 200 -19 288 0 96 20 237 92 320 162 85 71 176 176 176 203 0 27 -91 132 -176 203 -83 70 -224 142 -320 162 -85 18 -208 18 -293 0z m266 -123 c51 -27 98 -73 126 -126 29 -54 31 -174 3 -226 -25 -49 -84 -108 -131 -133 -57 -31 -173 -30 -231 0 -217 115 -197 413 33 499 51 19 148 12 200 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 760 c-87 -52 -83 -198 6 -245 98 -50 211 16 211 123 0 85 -56 142 -140 142 -27 0 -58 -8 -77 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPass);
export default __webpack_public_path__ + "static/media/show-pass.87f6f295e9f8923b028926349c30f18a.svg";
export { ForwardRef as ReactComponent };